export const EMPLOYEE_TYPES = [
  "Permanent",
  "Temporary",
  "Contract",
  "Probation",
  "Intern",
  "Trainee",
  "Consultant",
  "Part-Time",
  "Fixed Term",
  "Apprentice",
  "Daily Wage",
  "Seasonal",
  "Outsourced",
];

export const DEFAULT_EMPLOYEE_TYPE = "Permanent";

const LOOKUP = Object.fromEntries(EMPLOYEE_TYPES.map((t) => [t.toLowerCase(), t]));

export function normalizeEmployeeType(value) {
  if (!value || !String(value).trim()) return DEFAULT_EMPLOYEE_TYPE;
  const hit = LOOKUP[String(value).trim().toLowerCase()];
  return hit || null;
}

export function isValidEmployeeType(value) {
  if (!value || !String(value).trim()) return true;
  return Boolean(normalizeEmployeeType(value));
}
